import {debounce} from 'lodash-es';

/**
 * Pomocný objekt pro odesílání focus/blur událostí ze složeného formulářového pole.
 */
export default class CompositeFocusBlur {

    /**
     * Konstruktor.
     *
     * @param {object} target - nadřazená react komponenta, která má v props callback onFocus a onBlur
     * @param {object} [options] - extra parametry
     * @param {number} [options.delay=100] - prodleva (v ms) před vyvoláním onFocus/onBlur nadřazené komponenty
     */
    constructor(target, options = {}) {
        const {delay = 100} = options;

        this.target = target;
        this.counter = 0;
        this.prevCounter = 0;
        this.checkLater = debounce(() => this.check(), delay);
    }

    /**
     * Handlery, které se předají polím nadřazené komponenty.
     */
    handlers = {
        onFocus: () => {
            this.counter++;
            this.checkLater();
        },
        onBlur: () => {
            this.counter--;
            this.checkLater();
        },
    };

    check() {
        const {counter} = this;
        if (counter !== this.prevCounter) {
            this.prevCounter = counter;
            if (counter > 0) {
                this.target.props.onFocus();
            } else {
                this.target.props.onBlur();
            }
        }
    }

}
